import { SVGProps } from 'react';

export const Dot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    {...props}
  >
    <circle cx="5.5" cy="5.5" r="5.5" fill="currentColor" />
  </svg>
);
